export default __webpack_public_path__ + "assets/leme-component.61c06fd3.svg";